// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__1Euzv","messages":"Chat_messages__2N4bv","dateDivider":"Chat_dateDivider__1EuQR"};